import { useContext } from 'react';

import { ListContext } from '@contexts/ListContext';

const useNetworkAgencyDepartments = (networkAgencyId) => {
    const { cachedList } = useContext(ListContext);
    const deps = [];
    const singleAccountingGroup = cachedList.accountingGroups.items.length === 1;
    for (const accGroup of cachedList.accountingGroups.items) {
        const singleNetworkAgency = accGroup.NetworkAgencies.length === 1;
        for (const nwAg of accGroup.NetworkAgencies) {
            if (networkAgencyId) {
                if (nwAg.ID === networkAgencyId) {
                    for (const department of nwAg.Departments) {
                        deps.push({
                            ...department,
                            NetworkAgencyID: nwAg.ID,
                            NetworkAgencyName: nwAg.Name,
                            AccountingGroupID: accGroup.ID,
                            AccountingGroupName: accGroup.Name,
                        });
                    }
                }
            } else {
                for (const department of nwAg.Departments) {
                    deps.push({
                        ...department,
                        NetworkAgencyID: nwAg.ID,
                        NetworkAgencyName: nwAg.Name,
                        AccountingGroupID: accGroup.ID,
                        AccountingGroupName: accGroup.Name,
                        SingleAccountingGroup: singleAccountingGroup,
                        SingleNetworkAgency: singleNetworkAgency,
                    });
                }
            }
        }
    }
    return deps;
};

export default useNetworkAgencyDepartments;
